import React, { memo } from "react";
import { FormAnswersV2, SavedFormQuestion } from "@markit/common.types";
import { CircularProgress } from "@mui/material";
import { Colors } from "../../utils/colors";
import { useTheme } from "../../hooks/useTheme";
import SingularQuestionInput from "../../components/UserInfoContainers/SingularQuestionInput";

type FormQuestionsInputProps = {
  formQuestions: SavedFormQuestion[];
  answers: FormAnswersV2;
  setAnswers: (newAnswers: FormAnswersV2) => void;
  disabled: boolean;
  showQuestionsPreview?: boolean; // Used with disabled, shows the questions as a preview but is disabled
  verified: boolean;
  loading?: boolean;
  paymentOrRsvpElement?: React.ReactNode;
};

export const FormQuestionsInput = memo(function FormQuestionsInputFn(
  props: FormQuestionsInputProps
) {
  const {
    formQuestions,
    answers,
    setAnswers,
    disabled,
    verified,
    loading,
    paymentOrRsvpElement,
  } = props;

  const { theme } = useTheme();

  if ((disabled && verified) || loading) {
    return (
      <div
        className="Centering"
        style={{
          padding: "40px 14px",
        }}
      >
        <CircularProgress size={24} style={theme.PrimaryText} />
      </div>
    );
  }

  return (
    <div
      className="ColumnNormal"
      style={{
        gap: 14,
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? "none" : "all",
      }}
    >
      <div className="ColumnNormal" style={{ gap: 4 }}>
        <h4 className="NameAndNumber" style={theme.PrimaryText}>
          Questions
        </h4>
        {disabled ? (
          <span style={{ color: Colors.GRAY2, fontSize: 12 }}>
            Available after info entered
          </span>
        ) : null}
      </div>
      <div className="ColumnNormal" style={{ gap: 20 }}>
        {formQuestions.map((question) => {
          return (
            <div key={question.id}>
              <SingularQuestionInput
                question={question}
                formQuestions={formQuestions}
                answers={answers}
                setAnswers={setAnswers}
                disabled={false}
              />
            </div>
          );
        })}
      </div>
      {paymentOrRsvpElement}
    </div>
  );
});
